import InsufficientIcon from '../images/token-insufficient-icon.png';
import RevokedIcon from '../images/token-revoked-icon.png';
import TeamsLimitedIcon from '../images/token-teams-limited-icon.png';
import MoreIcon from '../images/dot-menu.svg';
import { Link } from 'react-router-dom';

export const faqList = [
  {
    pathname: require('../images/search-icon.svg'),
    header: 'General',
    subItems: [
      {
        header: 'What is Trova?',
        text: (
          <div>
            Trova is an AI-powered search engine for all your personal conversations and files. Our app connects all the different services you use like Gmail, Google Drive, Slack, Outlook, MS Teams, Dropbox, OneDrive, Jira, and more. You can search across these platforms to find the information you need quickly. Get started by simply creating an account on <a href="www.gotrova.ai" ><u>www.gotrova.ai</u></a> and start typing your search question.
          </div>
        )
      },
      {
        header: 'How does Trova work?',
        text: 'Trova uses advanced technologies like natural language processing (NLP) and artificial intelligence (AI) to help you find the information you need. Just type your question -- technically known as query -- and Trova finds the answer.',
      },
      {
        header: 'Is Trova free? ',
        text: 'All features of Trova are currently free. We may in the future start charging for some of our features, but we promise that there will always be a “free” option that allows users to quickly search personal data on the go.',
      },
      {
        header: 'Can I use Trova on my phone?',
        text: (
          <div>
            Yes, Trova works on your smartphone. Just use your smart phone’s browser app and access <a href="www.gotrova.ai" ><u>www.gotrova.ai</u></a> – just like you do on your PC or Mac. In the near future, there will be a "GoTrova" app for iPhone and Android smartphones.',
          </div>
        )
      },
    ]
  },
  {
    pathname: require('../images/menu-icon.svg'),
    header: 'Connecting Apps',
    subItems: [
      {
        header: 'What are the apps that I can integrate Trova with?',
        text: 'Trova currently supports Gmail, Google Drive, Slack, Outlook, MS Teams,  OneDrive, Jira. We are quickly adding other cloud apps. Once you create an account, we will keep you updated on the additional apps that you can integrate with Trova.'
      },
      {
        header: 'How can I connect my apps?',
        text: 'While creating your Trova account, you’ll be able to link your apps with Trova as onboarding. You can also visit “Accounts” to add services later.',
      },
      {
        header: 'I have multiple Gmail accounts, can I connect all of them to Trova?',
        text: 'Yes, you can connect as many Gmail accounts as you would like under the “Accounts” section. It works the same way for other platforms. You can connect multiple accounts to Slack, Outlook, Jira, Dropbox, etc. Each connected account is displayed in the account list.',
      },
      {
        header: 'I use Office 365 through my organization, can I connect it?',
        text: 'Yes, you can connect you work or school account(s) for Office 365. Click “Connect” in the accounts page, select “Sign-in options” and “Sign in to an organization”. You will be asked the name of your organization and your email address.'
      },
      {
        header: 'I use Microsoft Teams through my organization, can I connect it?',
        text: (
          <div>
            <p>
              Yes, you can connect you work or school account(s) for Microsoft Teams if your IT department allows 3rd party apps. If this setting is not automatically enabled, please ask your IT department to contact the Trova team at <a href="mailto:info@gotrova.ai" target="_blank" rel="noreferrer">info@gotrova.ai</a>.
            </p>
            <p>
              Once your authorization request is approved, click on “Connect” in the accounts page, select “Sign-in options” and “Sign in to an organization”. You will be asked the name of your organization and your email address.
            </p>
          </div>
        )
      },
      {
        header: 'How can I remove my apps?',
        text: (
          <div>
            By visiting “Accounts” and then selecting the “<img style={{ height: 16, paddingLeft: 2, paddingRight: 2 }} src={MoreIcon} alt="more icon" />” icon, you can remove accounts that are connected.
          </div>
        )
      },
      {
        header: 'There’s an icon next to my connected account, what does it mean?',
        text: (
          <div>
            <p>The icon indicates your connected account’s token status.</p>
            <p style={{display: 'flex', alignItems: 'flex-start'}} >
              <img src={RevokedIcon} style={{ height: 20, width: 20, marginRight: 10, marginTop: 10}} alt="revoked token icon" />
              <span> means that you are automatically signed out by your connected account (e.g., Gmail, Outlook). For security reasons, you will need to reconnect the account. This is likely due to changes in your connected account (e.g., a password change, exceeded the number of third-party apps you can
              have, or your organization’s third-party app session control constraints). You can also search
              “expired refresh token + [platform name]” on your preferred Web Search service to read more.
            </span>
            </p>
            <p style={{display: 'flex', alignItems: 'flex-start'}} >
              <img src={InsufficientIcon} style={{ height: 20, width: 20, marginRight: 10, marginTop: 10}} alt="insufficient token icon"  />
              <span> means that the connected account has not fully authorized Trova. Please reconnect the account, and select “View your email messages and settings” to authorize Trova to index and search the connected account’s content.</span>
            </p>
            <p style={{display: 'flex', alignItems: 'flex-start'}}>
              <img src={TeamsLimitedIcon} style={{ height: 20, width: 20, marginRight: 10, marginTop: 10}} alt="teams limited token icon" />
              <span> means your account is limited and requires authorization from your Office 365 admin before set up. Please ask your Office 365 admin to contact the Trova team at <a href="mailto:info@gotrova.ai" target="_blank" rel="noreferrer">info@gotrova.ai</a> to enjoy all the features that Trova provides. Setup is quick once we are connected.</span>
            </p>
          </div>
        )
      }, {
        header: 'My Teams account is connected but I cannot find Teams results. What should I do?',
        text: (
          <div>
            <p>
              Once your Teams account is connected, Trova may need some time to set it up. We will notify you and send you an email when your account is ready to search!
            </p>
          </div>
        )
      }, {
        header: 'How can I connect Slack with a different account?',
        text: (
          <div>
            <p>
              After clicking “Connect” in the Accounts page, open the drop-down menu in the top right of Slack’s authorization page. Select “Add another workspace”, type your workspace name and sign-in using your preferred account.
            </p>
          </div>
        )
      }
    ]
  },
  {
    pathname: require('../images/lock.svg'),
    header: 'Data & Privacy',
    subItems: [
      {
        header: 'How does Trova protect my data?',
        text: (
          <div>
            All user information is stored on military grade encrypted servers (AES-256). Trova only stores the data necessary to improve your search results. This means your data stays on account, e.g. all Gmail messages stay on Gmail. We just find the Gmail message you are looking for you. Most of the time faster and better than Gmail itself. Please refer to our <Link to="/tos"><u>Terms of Service</u></Link> and <Link to="/privacy"><u>Privacy Policy</u></Link> for more information.
          </div>
        ),
      },
      {
        header: 'What will Trova do with my data?',
        text: (
          <div>
            Trova uses your search queries and your feedback on the search results to help improve the product. We do not store or read any of the messages or the files. Please refer to our <Link to="/tos"><u>Terms of Service</u></Link> and <Link to="/privacy"><u>Privacy Policy</u></Link> for more information.
          </div>
        ),
      },
      {
        header: 'Will Trova provide my data to third parties?',
        text: (
          <div>
            Never! Your data is stored in military grade encryption servers (AES 256). We are GDPR and CCPA compliant. The company is in the process of passing SOC2 certification. Please refer to our <Link to="/tos"><u>Terms of Service</u></Link> and <Link to="/privacy"><u>Privacy Policy</u></Link> for more information.
          </div>
        ),
      },
      {
        header: 'Does Trova have access to all the accounts I connected to?',
        text: 'With your permission, Trova’s search engine will create a rich index of your messages, documents, chats.  This encrypted index is used by our AI algorithms to find your search result. Once we process your content, we delete it from our servers, keeping only the rich index.  When you make a query, we use our index to quickly find exactly what you need.  We periodically check your accounts for any new messages to ensure that our indexes are up-to-date.',
      },
      {
        header: 'Can I choose what data to share with Trova?',
        text: (
          <div>
            Yes, you can select what accounts connect with Trova. We only search the accounts that you have enabled for us to search. Please refer to our <Link to="/tos"><u>Terms of Service</u></Link> and <Link to="/privacy"><u>Privacy Policy</u></Link> for more information.
          </div>
        ),
      },
    ]
  },
  {
    pathname: require('../images/toolkey-icon.svg'),
    header: 'Troubleshooting',
    subItems: [
      {
        header: 'Please contact us for issues you encountered.',
        text: 'info@gotrova.ai',
      },
    ]
  }
];